import { addDateToPeriod, AvailabilityPeriod, createAvailabilityPeriod } from '../domain/AvailabilityPeriod';
import { WorkCalendarRecord } from '../types';
import { areTimeSlotsEqual } from './areTimeSlotsEqual';

export function groupAvailabilityPeriods(dates: WorkCalendarRecord[]): AvailabilityPeriod[] {
    if (!dates.length) {
        return [];
    }

    const periods: AvailabilityPeriod[] = [];
    let currentPeriod: AvailabilityPeriod | null = null;

    for (const date of dates) {
        if (!currentPeriod) {
            currentPeriod = createAvailabilityPeriod(date);
            continue;
        }

        const isSameStatus = date.status === currentPeriod.status;
        const hasSameTimeSlots = areTimeSlotsEqual(date.timeSlots || [], currentPeriod.timeSlots);

        if (isSameStatus && hasSameTimeSlots) {
            currentPeriod = addDateToPeriod(currentPeriod, date);
        } else {
            periods.push(currentPeriod);
            currentPeriod = createAvailabilityPeriod(date);
        }
    }

    if (currentPeriod && currentPeriod.status !== 'Unknown') {
        periods.push(currentPeriod);
    }

    return periods;
}
